module.exports = __webpack_public_path__ + "static/img/jp3.64991c4a.png";